import { FC } from 'react';
import { SignIn } from 'components/SignIn';

export const SignInPage: FC = () => {
	return <SignIn />;
};
